import { render, staticRenderFns } from "./CustomersMap.vue?vue&type=template&id=63634b68&scoped=true"
import script from "./CustomersMap.vue?vue&type=script&lang=js"
export * from "./CustomersMap.vue?vue&type=script&lang=js"
import style0 from "./CustomersMap.vue?vue&type=style&index=0&id=63634b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63634b68",
  null
  
)

export default component.exports